/** Base URL de la API REST (incluye `/api`). En Docker prod usa path relativo vía nginx. */
export function getApiBaseUrl(): string {
  if (import.meta.env.DEV) {
    return '/api';
  }
  const raw = String(import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL || '').trim();
  if (!raw) {
    return '/api';
  }
  return `${raw.replace(/\/$/, '')}/api`;
}
